import { journeyAction, } from './base';

import { JourneyActionStartVoiceOutbound as JourneyActionStartVoiceBase, } from 'atlas-shared';

export const JourneyActionStartVoiceOutbound = journeyAction({
  ...JourneyActionStartVoiceBase,
  icon: 'Voice',
});
